import { MdPending, MdCancel, MdPayments, MdLocalShipping, MdDone } from "react-icons/md";
import { TbPackage, TbTruck, TbClipboardCheck } from "react-icons/tb";
import { BsGearFill } from "react-icons/bs";

export const CATEGORY_CHOICES = [
    { value: 'IF', label: 'International Freight' },
    { value: 'DF', label: 'Destination Fee' },
    { value: 'CA', label: 'Company Audit' },
    { value: 'CI', label: 'Cargo Inspection' },
    { value: 'CF', label: 'Customs Fees' },
    { value: 'FF', label: 'Forwarder Fees' },
    { value: 'FA', label: 'Factory' },
    { value: "CIV", label: "CIF Insurance Value"},
    { value: 'OT', label: 'Others' },
];

export const SUPPLIER_TYPE_CHOICES = [
    { value: 'FACTORY', label: 'Factory' },
    { value: 'FORWARDER', label: 'Forwarder' },
    { value: 'COMPANY_AUDIT', label: 'Company Audit' },
];

export const ASSESSMENT_TYPE_CHOICES = [
    { value: 'FOB', label: 'FOB' },
    { value: 'CV', label: 'Customs Value' },
    { value: 'NF', label: 'NF' },
    { value: 'BC-ICMS', label: 'BC-ICMS' },
];

export const TAX_REGIME_CHOICES = [
    { value: 'Simples Nacional', label: 'Simples Nacional' },
    { value: 'Lucro Presumido', label: 'Lucro Presumido' },
    { value: 'Lucro Real', label: 'Lucro Real' }
];

// Centralized order status color definitions
export const ORDER_STATUS_COLORS = {
    'Awaiting Approval': '#FFA500',     // Orange
    'Discontinued': '#BDC3C7',          // Dark Grey
    'Ready for Processing': '#1ABC9C',   // Blue Green
    'Open': '#5B9BD5',                  // Light Blue
    'Awaiting Initial Payment': '#9B59B6', // Light Purple
    'Awaiting Packaging': '#76D7C4',     // Light Green
    'In Production': '#1F4E79',          // Dark Blue
    'Awaiting Inspection': '#F7DC6F',    // Light Yellow
    'Awaiting Final Payment': '#E74C3C',  // Light Red
    'Awaiting Shipment': '#A9A9A9',      // Grey
    'In Transit': '#F0C400',             // Yellow
    'Delivered': '#27AE60'               // Green
};

export const STATUS_CONFIG = {
    'Awaiting Approval': {
        color: ORDER_STATUS_COLORS['Awaiting Approval'],
        icon: MdPending
    },
    'Discontinued': {
        color: ORDER_STATUS_COLORS['Discontinued'],
        icon: MdCancel
    },
    'Ready for Processing': {
        color: ORDER_STATUS_COLORS['Ready for Processing'],
        icon: null
    },
    'Open': {
        color: ORDER_STATUS_COLORS['Open'],
        icon: null
    },
    'Awaiting Initial Payment': {
        color: ORDER_STATUS_COLORS['Awaiting Initial Payment'],
        icon: MdPayments
    },
    'Awaiting Packaging': {
        color: ORDER_STATUS_COLORS['Awaiting Packaging'],
        icon: TbPackage
    },
    'In Production': {
        color: ORDER_STATUS_COLORS['In Production'],
        icon: BsGearFill
    },
    'Awaiting Inspection': {
        color: ORDER_STATUS_COLORS['Awaiting Inspection'],
        icon: TbClipboardCheck
    },
    'Awaiting Final Payment': {
        color: ORDER_STATUS_COLORS['Awaiting Final Payment'],
        icon: MdPayments
    },
    'Awaiting Shipment': {
        color: ORDER_STATUS_COLORS['Awaiting Shipment'],
        icon: MdLocalShipping
    },
    'In Transit': {
        color: ORDER_STATUS_COLORS['In Transit'],
        icon: TbTruck
    },
    'Delivered': {
        color: ORDER_STATUS_COLORS['Delivered'],
        icon: MdDone
    }
};

export const STATUS_GROUPS = {
    COMPLETED: ['Delivered', 'Discontinued'],
    IN_PROGRESS: Object.keys(STATUS_CONFIG).filter(
        status => !['Delivered', 'Discontinued'].includes(status)
    )
};

export const INCOTERMS_CHOICES = [
    { value: 'FOB', label: 'FOB' },
    { value: 'CFR', label: 'CFR' },
    { value: 'CIF', label: 'CIF' },
    { value: 'EXW', label: 'EXW' },
    { value: 'FCA', label: 'FCA' },
];

// Product/Order purpose values - DO NOT CHANGE (used in database)
export const PURPOSE_RESALE = "resale";
export const PURPOSE_MANUFACTURING = "manufacturing";
export const PURPOSE_FIXED_ASSET = "fixed_asset";
export const PURPOSE_CONSUMPTION = "consumption";

// Purpose choices for models
export const PURPOSE_CHOICES = [
    { value: PURPOSE_RESALE, label: "For Resale" },
    { value: PURPOSE_MANUFACTURING, label: "For Manufacturing" },
    { value: PURPOSE_FIXED_ASSET, label: "For Fixed Asset" },
    { value: PURPOSE_CONSUMPTION, label: "For Consumption Use" },
];

// Payment Terms Constants (refactored)
export const PAYMENT_TYPE_CHOICES = [
    { value: 'ADVANCED', label: 'Advanced' },
    { value: 'BEFORE_LOADING', label: 'Before Loading' },
    { value: 'AGAINST_HBL', label: 'Against HBL' },
    { value: 'DAYS_AFTER_HBL_DATE', label: 'Days After HBL Date' },
    { value: 'WITHIN_DAYS_AFTER_ETA', label: 'Within Days After ETA' },
];

// Time-based payment types that require days_offset
export const TIME_BASED_PAYMENT_TYPES = [
    'DAYS_AFTER_HBL_DATE',
    'WITHIN_DAYS_AFTER_ETA',
];

// Payment Type Constants (exports for convenience)
export const ADVANCED = 'ADVANCED';
export const BEFORE_LOADING = 'BEFORE_LOADING';
export const AGAINST_HBL = 'AGAINST_HBL';
export const DAYS_AFTER_HBL_DATE = 'DAYS_AFTER_HBL_DATE';
export const WITHIN_DAYS_AFTER_ETA = 'WITHIN_DAYS_AFTER_ETA';

// Payment Status Colors
export const PAYMENT_STATUS_COLORS = {
  'TO_BE_ISSUED': '#808080',     // Neutral Gray
  'AWAITING_PAYMENT': '#5B9BD5', // Light Blue (same as order Open)
  'PAID': '#27AE60',             // Success Green (same as order Delivered)
  'OVERDUE': '#DC2626',          // Warning Red for overdue payments
  'CANCELLED': '#E74C3C'         // Error Red
};

// Late payment status colors
export const LATE_PAYMENT_COLORS = {
  'ON_TIME': '#27AE60',    // Green
  'LATE': '#DC2626'        // Red
};
